import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { reduxForm, getFormValues, getFormSyncErrors } from "redux-form";
import userContext from "../../userContext";
import { FORM_NAME } from "../contact.constants";
import ContactForm from "./ContactForm";
import controls from "../../controls";
import utilities from "../../utilities";
import { saveOnBlur } from "../../userContext/userContext.actions";

const {
  validations: { validateAccountForm }
} = controls;

const {
  transform: { sanitizeValue }
} = utilities;

const {
  actions: { patchUser: patchUserCreator },
  selectors: { getUserContext, getRedirect },
  actions: { logout: logoutCreator }
} = userContext;

class ContactFormContainer extends Component {
  componentDidUpdate(prevProps) {
    const { initialValues, formSyncErrors, touch, untouch } = this.props;

    if (formSyncErrors) {
      const latestErrors = validateAccountForm(initialValues);
      touch(
        ...Object.keys(formSyncErrors).filter(k =>
          initialValues.hasOwnProperty(k)
        )
      );
      untouch(
        ...Object.keys(latestErrors).filter(k => latestErrors[k] === undefined)
      );
    }
  }

  handleBlur = e => {
    const { initialValues, saveOnBlur, patchUser } = this.props;
    if (e.nativeEvent && e.nativeEvent.relatedTarget)
      saveOnBlur(e.nativeEvent.relatedTarget.getAttribute("name"));

    if (!e.target.value && !initialValues[e.target.name]) {
      return;
    }

    if (e.target.value === initialValues[e.target.name]) {
      return;
    }

    patchUser({
      [e.target.name]: sanitizeValue(e.target.value)
    });
  };

  render() {
    return (
      <ContactForm onBlur={this.handleBlur} showPin={this.props.showPin} />
    );
  }
}

ContactFormContainer.propTypes = {
  patchUser: PropTypes.func.isRequired,
  formSyncErrors: PropTypes.object
};

const mapStateToProps = state => ({
  formValues: getFormValues(FORM_NAME)(state),
  formSyncErrors: getFormSyncErrors(FORM_NAME)(state),
  initialValues: getUserContext(state),
  redirect: getRedirect(state)
});

const mapDispatchToProps = dispatch => ({
  patchUser: payload => dispatch(patchUserCreator(payload)),
  logout: () => dispatch(logoutCreator()),
  saveOnBlur: fieldOnTab => dispatch(saveOnBlur(fieldOnTab))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: FORM_NAME,
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
    destroyOnUnmount: false,
    validate: validateAccountForm
  })(ContactFormContainer)
);
